import daesEndpoint from 'app/api/services/daesEndpoint';
import notification from 'app/config/notification';

export const daeIsPaid = async (cdSolicitacao, dePlaca, intl) => {
  if (cdSolicitacao && dePlaca) {
    try {
      const response = await daesEndpoint.getStatusDAE(dePlaca, cdSolicitacao);
      if (response.status === 200) {
        if (response.data) {
          notification(
            intl.formatMessage({
              id: 'MESSAGES.SERVICE.FORMS.DELETE_VEHICLE_ERROR_DAE_PAID',
            }),
            {
              toastId: 'MESSAGES.SERVICE.FORMS.DELETE_VEHICLE_ERROR_DAE_PAID',
              type: 'error',
            }
          );
        }
        return response.data;
      }
    } catch (error) {
      notification(
        intl.formatMessage({
          id: 'MESSAGES.SERVICE.FORMS.ERROR_DAE_PAID',
        }),
        {
          toastId: 'MESSAGES.SERVICE.FORMS.ERROR_DAE_PAID',
          type: 'error',
        }
      );
    }
  } else {
    notification(
      intl.formatMessage({
        id: 'MESSAGES.SERVICE.FORMS.ERROR_DAE_PAID',
      }),
      {
        toastId: 'MESSAGES.SERVICE.FORMS.ERROR_DAE_PAID',
        type: 'error',
      }
    );
  }
  return true;
};

export const cancelDAE = async (cdSolicitacao, deletedVehicles) => {
  if (!cdSolicitacao || !deletedVehicles) return false;
  if (cdSolicitacao && deletedVehicles && deletedVehicles.length > 0) {
    try {
      for (const v of deletedVehicles) {
        const plate = v.dePlaca || v.veiculo.dePlaca || null;
        if (!plate) return false;
        const response = await daesEndpoint.cancelDAE(plate, cdSolicitacao);
        if (response.status !== 200) {
          notification(
            'Problemas ao salvar. Não foi possível cancelar DAE gerada para o veículo excluído.',
            {
              toastId: 'CANCEL_DAE_PROBLEM',
              type: 'error',
            }
          );
          return false;
        }
      }
    } catch (error) {
      return false;
    }
  }

  return true;
};
